<template>
  <div class="roleDetail">
    <v-jstree
      v-if="finished"
      :data="treeData"
      size="large"
      show-checkbox
      multiple
      allow-batch
      whole-row
      @item-click="itemClick"
    ></v-jstree>

    <div class="tool-bar" v-if="finished">
      <van-button type="info" block @click="onSubmit">{{ $t.meta.save }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button } from "vant";
Vue.use(Button);

export default {
  name: "roleDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      roleId: "",
      treeData: [],
      finished: false,
    };
  },
  created() {
    const { RoleId } = this.$route.query;
    if (RoleId) {
      this.roleId = RoleId;
      this.getRolesRight();
    }
  },
  methods: {
    itemClick(node) {
      var onSelect = (data) => {
        var count = 0;
        var childs = data.children;
        for (var child of childs) {
          if (child.selected) {
            count = count + 1;
          }
        }
        if (count > 0) {
          data.selected = true;
        } else {
          data.selected = false;
        }
      };
      var parent = node.$parent.model; //上一级节点
      if (parent) {
        onSelect(parent);
      }
      var grandpa = node.$parent.$parent.model; //上上级节点
      if (grandpa) {
        onSelect(grandpa);
      }
    },
    getLeafKeys(node) {
      var result = [];
      node.forEach((item1) => {
        if (item1.selected) {
          if (result.find((id) => id == item1.id)) {
          } else {
            result.push(item1.id);
          }
          if (item1.children.length) {
            item1.children.forEach((item2) => {
              if (item2.selected) {
                if (result.find((id) => id == item2.id)) {
                } else {
                  result.push(item2.id);
                }
                if (item2.children.length) {
                  item2.children.forEach((item3) => {
                    if (item3.selected) {
                      if (result.find((id) => id == item3.id)) {
                      } else {
                        result.push(item3.id);
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });
      return result;
    },
    onSubmit() {
      var param = {
        RoleId: this.roleId,
        MenuIdList: this.getLeafKeys(this.treeData),
        CompanyId: this.CompanyId,
      };
      this.$commonMethod.showLoading();
      this.$api.systemManagement
        .setRolesRight(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getRolesRight() {
      this.$commonMethod.showLoading();
      var param = {
        CompanyId: this.CompanyId,
        RoleId: this.roleId,
      };
      this.$api.systemManagement
        .getRolesRight(param)
        .then((res) => {
          this.formatData(res.data);
          this.finished = true;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    formatData(arr) {
      var result = arr;
      result.forEach((item1) => {
        item1.text = item1.MenuName;
        item1.id = item1.MenuId;
        item1.selected = item1.IsPermission == 1 ? true : false;
        item1.opened = true;
        item1.children = [];
        if (item1.ChildList.length) {
          item1.children = item1.ChildList;
          for (var item2 of item1.ChildList) {
            item2.text = item2.MenuName;
            item2.id = item2.MenuId;
            item2.selected = item2.IsPermission == 1 ? true : false;
            item2.opened = true;
            item2.children = [];
            if (item2.ChildList.length) {
              item2.children = item2.ChildList;
              for (var item3 of item2.ChildList) {
                item3.text = item3.MenuName;
                item3.id = item3.MenuId;
                item3.selected = item3.IsPermission == 1 ? true : false;
              }
            }
          }
        }
      });
      this.treeData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.roleDetail {
  ::v-deep .tree-themeicon {
    display: none !important;
  }
  ::v-deep .tree-anchor {
    width: 100%;
    font-size: 16px;
  }
  ::v-deep .tree-wholerow {
    background: #ffffff;
  }
  ::v-deep .tree-wholerow-clicked {
    background: #f1f1f1 !important;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
